import { useDataStore } from '@/stores/dataStore';

/**
 * App-wide unread totals — sum the per-channel counts into one pair. Shared by
 * the tab-title badge, the favicon badge and the desktop taskbar badge so they
 * all read the same number. Mentions are tracked separately because they get a
 * louder treatment (red pill / count) than plain unread (a quiet dot).
 */
export function readUnreadTotals(): { total: number; mentions: number } {
  const state = useDataStore.getState();
  // Only count channels the UI can actually surface. `channel:activity` fans
  // out to the entire guild room by design, while our channel list is filtered
  // by VIEW_CHANNEL — and a DM removed "for me" leaves the store entirely. Both
  // left counters the sidebar never showed and the user could never clear
  // (there is no row to open), i.e. a permanent phantom "(1)" in the tab title,
  // favicon and taskbar badge. The counters themselves are kept: the row can
  // come back (a re-fetch un-hides a DM, a role grant reveals a channel) and
  // then the badge is legitimate again.
  const known = new Set<string>(Object.keys(state.dmChannels));
  for (const guild of Object.values(state.guilds)) {
    for (const channel of guild.channels) known.add(channel.id);
  }
  let total = 0;
  let mentions = 0;
  for (const [channelId, v] of Object.entries(state.unreadByChannel)) {
    if (known.has(channelId)) total += v ?? 0;
  }
  for (const [channelId, v] of Object.entries(state.mentionByChannel)) {
    if (known.has(channelId)) mentions += v ?? 0;
  }
  return { total, mentions };
}
